import { i18n } from "@/resources/locales";

export const ROLE_SUPER_ADMIN = "ROLE_SUPER_ADMIN";
export const ROLE_ADMIN = "ROLE_ADMIN";
export const ROLE_USER = "ROLE_USER";
export const ROLE_TEACHER = "TEACHER";
export const ROLE_STUDENT = "STUDENT";

export const FILTER_PERMISSIONS = [
  {
    id: 0,
    label: i18n.t("manageUsers.filter.all"),
  },
  {
    id: 6,
    label: i18n.t("manageUsers.filter.disabled"),
  },
  {
    id: 8,
    label: i18n.t("manageUsers.filter.userOnline"),
  },
  {
    id: 1,
    label: i18n.t("manageUsers.filter.admin"),
  },
  {
    id: 3,
    label: i18n.t("manageUsers.filter.webinar"),
  },
  {
    id: 4,
    label: i18n.t("manageUsers.filter.globalMessage"),
  },
  {
    id: 5,
    label: i18n.t("manageUsers.filter.isTrial"),
  },
  {
    id: 2,
    label: i18n.t("manageUsers.filter.canInvite"),
  },

  {
    id: 9,
    label: i18n.t("manageUsers.filter.canPinChatMessage"),
  },
  {
    id: 10,
    label: i18n.t("manageUsers.filter.canBan"),
  },
  {
    id: 7,
    label: i18n.t("manageUsers.filter.none"),
  },
];

export const CHANGE_PERMISSIONS = [
  {
    value: "isWebinarHost",
    label: i18n.t("manageUsers.filter.webinar"),
  },
  {
    value: "canSendConsoleMessage",
    label: i18n.t("manageUsers.filter.globalMessage"),
  },
  {
    value: "isTrial",
    label: i18n.t("manageUsers.filter.isTrial"),
  },
  {
    value: "canInvite",
    label: i18n.t("manageUsers.filter.canInvite"),
  },
  {
    value: "canChangeRoomPin",
    label: i18n.t("manageUsers.filter.canChangeRoomPin"),
  },
  {
    value: "canPinChatMessage",
    label: i18n.t("manageUsers.filter.canPinChatMessage"),
  },
  {
    value: "canBan",
    label: i18n.t("manageUsers.filter.canBan"),
  },
];
